export default {
  isAuthenticated: state => {
    return state.isAuthenticated
  },
  profile: state => {
    return state.user
  },
}
